module.exports = __webpack_public_path__ + "img/sand-decal-21.8d179671.png";